import AmenityTable from "@/app/app-shared/amenity/amenity-table";

export default function AmenityPage() {
  return <AmenityTable />;
}
